import Item from "@/components/Item";
import { useItemModal } from "@/contexts/ItemModalProvider";
import { useItems } from "@/hooks/useItems";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router";

export default function searchResultsScreen() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const { t } = useTranslation();
  const { open } = useItemModal();
  const navigate = useNavigate();

  const { data: items } = useItems(query);

  console.log(items);

  return (
    <div className="px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 py-20 gap:10 sm:gap-16 lg:gap-20 flex flex-col">
      <h1 className="text-4xl font-semibold">
        {t("showing_results_for")} "{query}"
      </h1>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items?.map((item) => (
          <Item
            {...item}
            imageUrl={item.image ?? undefined}
            restaurantName={item.companyName}
            onClick={() => {
              open({
                item,
                ctaText: "Order",
                onCtaClick: () => {
                  navigate(`/restaurants/${item.companyId}/items/${item.id}`);
                },
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}
